import * as Scrivito from "scrivito";
import React, { memo } from "react";
import { getHomepage } from "utils";
import cx from "classnames";

const WizardLinkComponent = Scrivito.connect(
  ({ node, params, text, disabled, handleToggleNodeActiveStatus }) => (
    <Scrivito.LinkTag
      onClick={() => {
        !disabled &&
          Scrivito.navigateTo(getHomepage()?.get("configWizardObjRefs")?.[1], {
            params,
          });
        const nodeIsActive = node?.data.active;
        !nodeIsActive &&
          typeof handleToggleNodeActiveStatus === "function" &&
          handleToggleNodeActiveStatus();
      }}
      className={cx("ms-2", { "cursor-not-allowed": disabled })}
      id={`project-structure-wizard-link-${node?.id}`}
    >
      {text}
    </Scrivito.LinkTag>
  ),
);

export const WizardLink = memo(
  ({ node, params, text, disabled, handleToggleNodeActiveStatus }) => (
    <WizardLinkComponent
      node={node}
      params={params}
      text={text}
      disabled={disabled}
      handleToggleNodeActiveStatus={handleToggleNodeActiveStatus}
    />
  ),
);
